import { render } from "./ProductGroupTable.vue?vue&type=template&id=694469c8&scoped=true"
import script from "./ProductGroupTable.vue?vue&type=script&lang=js"
export * from "./ProductGroupTable.vue?vue&type=script&lang=js"

import "./ProductGroupTable.vue?vue&type=style&index=0&id=694469c8&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694469c8"]])

export default __exports__